<template>
  <router-view />
</template>

<script setup>
import { provide } from 'vue';
import { useOrganisation } from '@/functions/use_remote_object';

const props = defineProps({
  organisationId: String
});

const organisation = useOrganisation(props);
provide('currentOrganisation', organisation);
</script>
